<div [ngClass]="{ 'light text-white-dark': 'dark text-white-dark' }">
  <nav class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
    <div class="h-full bg-white dark:bg-[#0e1726]">
      <div class="flex items-center justify-between px-1 py-3">
        <a routerLink="/" class="main-logo flex shrink-0 items-center">
          <img class="ml-[5px] w-[230px] flex-none" src="/assets/images/LogoDash.svg" alt="" />
        </a>
        <a
          href="javascript:;"
          class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary dark:text-white-light dark:hover:bg-dark-light/10 rtl:rotate-180"
          (click)="storeData.dispatch({ type: 'toggleSidebar'})"
        >
          <icon-carets-down class="m-0 rotate-90" />
        </a>
      </div>
      <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
        <ul class="relative space-y-0.5 p-4 py-0 font-semibold">
          <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
            <icon-minus class="hidden h-5 w-4 flex-none" />
            <span>{{ ('customer_service' | translate) || '&nbsp;' }}</span>
          </h2>

          <li *appHasRole="[roles.SuperAdmin, roles.SuperAdminLight]" class="nav-item">
            <ul>
              <li class="nav-item">
                <a routerLink="/instance-requests" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-folder-minus class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'requests' | translate}}</span>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/users" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-users-group class="shrink-0 group-hover:!text-primary" />
                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'customers_label' | translate }}</span>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/billing" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-bill class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'billing_label' | translate }}</span>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/statistics" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-bar-chart class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'statistics_label' | translate }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </li>

          <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
            <icon-minus class="hidden h-5 w-4 flex-none" />
            <span>{{ ('internal_settings' | translate) || '&nbsp;' }}</span>
          </h2>

          <li class="nav-item">
            <ul>
              <li class="nav-item">
                <a routerLink="/blogs" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-notes-edit class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'blogs_sidebar' | translate }}</span>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/testemonials" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-award class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'testemonial.title' | translate }}</span>
                  </div>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/tier-managment" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-tuning class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'tier_managment' | translate }}</span>
                  </div>
                </a>
              </li>

              <li class="nav-item">
                <a routerLink="/questions" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-help-circle class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'qna.sidebar' | translate }}</span>
                  </div>
                </a>
              </li>
              <li *appHasRole="[roles.SuperAdmin]" class="nav-item">
                <a routerLink="/admins" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                  <div class="flex items-center">
                    <icon-user class="shrink-0 group-hover:!text-primary" />

                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'users' | translate }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </li>

          <li class="accordion menu nav-item" *ngIf="userRole !==roles.SuperAdmin">
            <button type="button" class="nav-link group w-full" [ngClass]="{ active: activeDropdown.includes('users') }" (click)="toggleAccordion('users')">
              <div class="flex items-center">
                <icon-menu-users class="shrink-0 group-hover:!text-primary" />

                <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">{{ 'user' | translate }}</span>
              </div>
              <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('users') }">
                <icon-caret-down />
              </div>
            </button>
            <div [@slideDownUp]="!activeDropdown.includes('users')" class="accordion-content">
              <ul class="sub-menu text-gray-500">
                <li>
                  <a routerLink="/profile" routerLinkActive="active" (click)="toggleMobileMenu()">{{ 'profile' | translate }}</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </ng-scrollbar>
    </div>
  </nav>
</div>
